import {Component} from 'react'

import './index.css'

import HistoryItem from '../HistoryItem'

const initialHistoryList = [
  {
    id: 0,
    timeAccessed: '07:45 PM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/instagram-img.png',
    title: 'Instagram',
    domainUrl: 'instagram.com',
  },
  {
    id: 1,
    timeAccessed: '05:45 PM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/twitter-img.png',
    title: 'Twitter. It’s what’s happening / Twitter',
    domainUrl: 'twitter.com',
  },
  {
    id: 2,
    timeAccessed: '04:35 PM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/facebook-img.png',
    title: 'Facebook – log in or sign up',
    domainUrl: 'facebook.com',
  },
  {
    id: 3,
    timeAccessed: '04:25 PM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/linkedin-img.png',
    title: 'LinkedIn: Log In or Sign Up',
    domainUrl: 'linkedin.com',
  },
  {
    id: 4,
    timeAccessed: '04:00 PM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/hashnode-img.png',
    title: 'Hashnode: Everything you need to start blogging as a developer!',
    domainUrl: 'hashnode.com',
  },
  {
    id: 5,
    timeAccessed: '03:25 PM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/github-img.png',
    title: 'GitHub: Where the world builds software · GitHub',
    domainUrl: 'github.com',
  },

  {
    id: 6,
    timeAccessed: '02:45 PM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/react-img.png',
    title: 'React – A JavaScript library for building user interfaces',
    domainUrl: 'reactjs.org',
  },
  {
    id: 7,
    timeAccessed: '01:25 PM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/stackoverflow-img.png',
    title: 'Stack Overflow - Where Developers Learn, Share, & Build Careers',
    domainUrl: 'stackoverflow.com',
  },

  {
    id: 8,
    timeAccessed: '09:25 AM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/gmail-img.png',
    title: 'Gmail',
    domainUrl: 'mail.google.com',
  },
  {
    id: 9,
    timeAccessed: '09:00 AM',
    logoUrl: 'https://assets.ccbp.in/frontend/react-js/google-img.png',
    title: 'Google',
    domainUrl: 'google.com',
  },
]

class BrowserHistory extends Component {
  state = {
    HistoryInput: '',
    HistoryList: initialHistoryList,
    listLength: initialHistoryList.length,
  }

  onChangeInput = event => {
    this.setState({HistoryInput: event.target.value})
  }

  onDeleteHistory = id => {
    const {HistoryList} = this.state

    const filteredList = HistoryList.filter(eachItem => eachItem.id !== id)

    this.setState({HistoryList: filteredList, listLength: filteredList.length})
  }

  render() {
    const {HistoryInput, HistoryList, listLength} = this.state

    const filteredList = HistoryList.filter(eachItem =>
      eachItem.title.toLowerCase().includes(HistoryInput.toLowerCase()),
    )

    const historyDisplayList = filteredList.map(eachItem => (
      <HistoryItem
        key={eachItem.id}
        historyItem={eachItem}
        onDelete={this.onDeleteHistory}
      />
    ))

    const emptyHistoryDisplayMsg = (
      <p className="empty-history-msg">There is no history to show</p>
    )

    return (
      <div className="browserHistory-bg-container">
        <div className="browserHistory-header">
          <img
            className="history-name-logo"
            src="https://assets.ccbp.in/frontend/react-js/history-website-logo-img.png"
            alt="app logo"
          />
          <div className="search-history-container">
            <img
              className="search-icon-logo"
              src="https://assets.ccbp.in/frontend/react-js/search-img.png"
              alt="search"
            />
            <input
              className="search-history-input"
              type="search"
              placeholder="Search history"
              onChange={this.onChangeInput}
            />
          </div>
        </div>

        <div className="browserHistory-footer">
          {listLength > 0 && historyDisplayList.length > 0 ? (
            <ul className="history-items-container">{historyDisplayList}</ul>
          ) : (
            <div className="empty-history-msg-container">
              {emptyHistoryDisplayMsg}
            </div>
          )}
        </div>
      </div>
    )
  }
}
export default BrowserHistory
